module.exports = __webpack_public_path__ + "img/sidebtn-active.6eda66dc.png";